import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

export const usuariosRotas = (): RouteRecordRaw[] => [
  {
    path: "/usuarios",
    name: "Usuarios",
    meta: {
      titulo: t("tituloDaRotaDeUsuarios"),
      regras: ["auth", "cancelador"],
      modulo: "Usuarios",
      operador: "e",
      permissoes: ["listar", "visualizar"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Usuarios" */
        "@/paginas/Usuarios/ListaDeUsuarios/ListaDeUsuarios.vue"
      ),
  },
  {
    path: "/usuarios/novo-usuario",
    name: "NovoUsuario",
    meta: {
      titulo: t("tituloDaRotaDeCriarUsuario"),
      regras: ["auth", "cancelador"],
      modulo: "Usuarios",
      operador: "e",
      permissoes: ["criar"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Usuarios" */
        "@/paginas/Usuarios/NovoUsuario/NovoUsuario.vue"
      ),
  },
  {
    path: "/usuarios/editar-usuario/:idUsuario",
    name: "EditarUsuario",
    props: true,
    meta: {
      titulo: t("tituloDaRotaDeEditarUsuario"),
      regras: ["auth", "cancelador"],
      modulo: "Usuarios",
      operador: "e",
      permissoes: ["editar"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Usuarios" */
        "@/paginas/Usuarios/NovoUsuario/NovoUsuario.vue"
      ),
  },
]
